import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let SelectClassify = class SelectClassify extends Vue {
    handleSelect() {
        this.$emit("handle-select");
    }
};
tslib_1.__decorate([
    Prop({ type: Number, default: 41 })
], SelectClassify.prototype, "fontLength", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], SelectClassify.prototype, "topicTypeName", void 0);
SelectClassify = tslib_1.__decorate([
    Component({
        name: 'SelectClassify',
    })
], SelectClassify);
export default SelectClassify;
